import React from 'react';
import PropTypes from 'prop-types';

// import hooks
import useKenwoodStickyFilters from '@/hooks/listing/Kenwood/useKenwoodStickyFilters';

// import components
import FacetDesktop from '@/kenwood/components/molecules/FacetDesktop';
import SortDesktopFilter from '@/kenwood/components/molecules/SortDesktopFilter';

const FiltersBarDesktop = ({
  filtersData,
  filterByLabel,
  sortByLabel,
  applyLabel,
  onApplyFilter,
  onApplySort,
}) => {
  const { isSticky, wrapperRef } = useKenwoodStickyFilters();
  if (!filtersData) return null;
  const facets = filtersData.facets || [];
  return (
    <section
      ref={wrapperRef}
      className={`ken-plp__filters__desktop-bar__wrapper ${
        isSticky ? ' --sticky' : ''
      }`}
    >
      <section className='ken-plp__filters__desktop-bar ken-wrapper--full-grid'>
        <section className='ken-plp__filters__desktop-bar__content ken-wrapper--big-grid'>
          <span className='ken-plp__filters__desktop-bar__filter-label'>
            {filterByLabel}:
          </span>
          <section className='ken-plp__filters__desktop-bar__filter-content'>
            {facets.map(facet => (
              <FacetDesktop
                key={facet.code}
                facet={facet}
                applyLabel={applyLabel}
                onApplyFilter={onApplyFilter}
              />
            ))}
          </section>
          <SortDesktopFilter
            sorts={filtersData.sorts}
            sortByLabel={sortByLabel}
            onApplySort={onApplySort}
          />
        </section>
      </section>
    </section>
  );
};

FiltersBarDesktop.propTypes = {
  filtersData: PropTypes.shape(),
  filterByLabel: PropTypes.string,
  sortByLabel: PropTypes.string,
  applyLabel: PropTypes.string,
  onApplyFilter: PropTypes.func,
  onApplySort: PropTypes.func,
};

FiltersBarDesktop.defaultProps = {
  filtersData: null,
  filterByLabel: 'Filter by',
  sortByLabel: 'Sort by',
  applyLabel: 'APPLY',
  onApplyFilter: null,
  onApplySort: null,
};

export default FiltersBarDesktop;
